import React from "react";
import {
  REPORT_WIZARD_STEPS,
  ReportsWizardStep,
  useReportsWizard,
} from "./ReportsWizardProvider";
import { classNames } from "../utils";
import { CheckIcon } from "@heroicons/react/24/outline";

type Props = {};

export const ReportsWizardSidebar = (props: Props) => {
  const { currentStep, steps, getChecktypeInfo } = useReportsWizard();
  function isLastStep(step: ReportsWizardStep) {
    return step.idx === (steps?.length ?? 0) - 1;
  }

  function showItem(stepIdx: number) {
    if (stepIdx === REPORT_WIZARD_STEPS.DOCUMENT_UPLOAD) {
      const checktypeInfo = getChecktypeInfo();
      return (checktypeInfo?.selectedThreeSixtyChecktype.length ?? 0) > 0;
    }
    return true;
  }

  return (
    <div>
      {steps.slice(1).map((step) => (
        <div
          key={step.idx}
          className={classNames(
            "relative flex gap-2 text-xs ",
            showItem(step.idx) ? "" : "hidden",
            isLastStep(step) ? "" : "h-[55px]",
            step.idx === currentStep ? "text-darkBlue" : "text-gray-400"
          )}
        >
          <div className="flex gap-2 h-5 items-center ">
            <div
              className={classNames(
                "w-[18px] h-[18px] rounded-full border flex items-center justify-center",
                step.isCompleted ? "text-white bg-green-600" : "",
                step.idx === currentStep ? "border-darkBlue" : "border-gray-400"
              )}
            >
              {step.isCompleted ? <CheckIcon className="w-3" /> : <></>}
            </div>
            <div>{step.label}</div>
          </div>
          {isLastStep(step) ? (
            <></>
          ) : (
            <div
              className={classNames(
                "absolute left-[8px] top-[19px] w-[2px] h-[37px]",
                step.isCompleted ? "bg-darkBlue" : "bg-gray-300"
              )}
            ></div>
          )}
        </div>
      ))}
    </div>
  );
};
